export default "__VITE_ASSET__BkbCcdgR__"